/*=========================================================================================
  File Name: moduleCourseMutations.js
  Description: Course Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ADD_ITEM(state, item) {
    state.courses.unshift(item)
  },
  SET_Courses(state, courses) {
    state.courses = courses
  },
  SET_AllModules(state, allModules) {
    state.allModules = allModules
  },

  SET_Modes(state, modes) {
    state.modes = modes
  },

  UPDATE_Course(state, course) {
    const courseIndex = state.courses.findIndex((p) => p.ID == course.ID)
    Object.assign(state.courses[courseIndex], course)
},
REMOVE_ITEM(state, itemId) {
    const ItemIndex = state.courses.findIndex((p) => p.ID == itemId)
    state.courses.splice(ItemIndex, 1)
},
SET_CourseFacilities(state, courseFacilities) {
  state.courseFacilities = courseFacilities;
},
ADD_Facility(state, item) {
  state.courseFacilities.unshift(item)
},
REMOVE_Facility(state, itemId) {
  const ItemIndex = state.courseFacilities.findIndex((p) => p.FacilityID == itemId)
 if(ItemIndex!=-1)
  state.courseFacilities.splice(ItemIndex, 1)
},

SET_CourseEvaluationMean(state, courseEvaluationMeans) {
  state.courseEvaluationMeans = courseEvaluationMeans;
},

ADD_EvaluationMean(state, item) {
  debugger
  state.courseEvaluationMeans.unshift(item);
  
},

REMOVE_EvaluationMean(state, itemId) {
  const ItemIndex = state.courseEvaluationMeans.findIndex((p) => p.EvaluationMeanID == itemId)
 if(ItemIndex!=-1)
  state.courseEvaluationMeans.splice(ItemIndex, 1)
},


SET_CourseModule(state, courseModule) { 
  state.courseModules = courseModule;
},

SET_Material(state, materials) { 
  state.materials = materials;
},

SET_CourseInstructor(state, instructors) {
  state.instructors = instructors;
},

ADD_Module(state, item) {
  state.courseModules.unshift(item);
},

Clear_ActiveModule(state)
{
  state.courseModules=state.courseModules.map(function(val){val.IsActive=false; return val; })
},

REMOVE_Module(state, moduleName) 
{
  const ItemIndex = state.courseModules.findIndex((p) => p.Name == moduleName)
 if(ItemIndex!=-1)
  state.courseModules.splice(ItemIndex, 1)
},


ADD_ModuleMaterial(state,moduleName ,item) {
  const ModuleIndex = state.courseModules.findIndex((p) => p.Name == moduleName)
  if(ModuleIndex!=-1)
  {
    
    if( state.courseModules[ModuleIndex].CourseModuleMaterials==undefined)
      state.courseModules[ModuleIndex].CourseModuleMaterials=[];
      const MaterialIndex = state.courseModules[ModuleIndex].CourseModuleMaterials.findIndex((p) => p.Name ==item.Name)
      if(MaterialIndex==-1)
        state.courseModules[ModuleIndex].CourseModuleMaterials.unshift(item);
  }
},

REMOVE_ModuleMaterial(state, moduleName,materialName) 
{
  const ModuleIndex = state.courseModules.findIndex((p) => p.Name == moduleName)
    if(ModuleIndex!=-1)
    {
      const MaterialIndex = state.courseModules[ModuleIndex].CourseModuleMaterials.findIndex((p) => p.Name == materialName)
        state.courseModules[ModuleIndex].CourseModuleMaterials.splice(MaterialIndex, 1)
    }
},

  ADD_Material(state, item) {
    state.courseMaterials.unshift(item);
  },

  REMOVE_Material(state, materialName) 
  {
    const ItemIndex = state.courseMaterials.findIndex((p) => p.Name == materialName)
    if(ItemIndex!=-1)
      state.courseMaterials.splice(ItemIndex, 1)
  },

  SET_CourseMaterial(state, materials) {
    state.courseMaterials = materials;
  },

  SET_CourseLanguages(state, languages) {
    state.languages = languages
  },

  SET_CourseTypes(state, courseTypes) {
    state.courseTypes = courseTypes
  },
}
